const staticModalModule = (() => {
  const init = async (path, containerId = 'staticModalContainer', event = null) => {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    const container = document.getElementById(containerId);
    if (!container || !path) return;

    container.innerHTML = ''; // Clear previous modal if any
    container.style.display = 'block';

    container.innerHTML = `
      <div id="staticModalOverlay" class="static-modal-overlay" onclick="staticModalModule.close(event)">
        <div class="static-modal-content" onclick="event.stopPropagation()">
          <button class="static-modal-close" onclick="staticModalModule.close()" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path fill="var(--mobile-top-button-color)" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
          <div id="staticModalBody">Loading...</div>
        </div>
      </div>
    `;

    setTimeout(() => open(path), 0);
  };



  const open = async (path) => {
    const overlay = document.getElementById('staticModalOverlay');
    const body = document.getElementById('staticModalBody');
    if (!overlay || !body) return;

    body.innerHTML = 'Loading...';
    overlay.style.display = 'flex';

    try {
      const res = await fetch(path);
      if (!res.ok) throw new Error('Failed to load content');

      const html = await res.text();
      body.innerHTML = html;
      replaceSiteNameInPolicyAndTerms();
    } catch (err) {
      body.innerHTML = '<p>Error loading content.</p>';
    }
  };

  function replaceSiteNameInPolicyAndTerms() {
    const siteName = getSiteName();
    if (siteName === 'ResumeInMinutes.com') return;

    // Select only elements explicitly marked for site name replacement
    const elements = document.querySelectorAll('.static-story-section .sitename-here');

    elements.forEach(el => {
      el.innerHTML = el.innerHTML.replace(/ResumeInMinutes\.com/g, siteName);
    });
  }


  const close = () => {
    const overlay = document.getElementById('staticModalOverlay');
    const container = overlay?.parentElement;

    if (overlay && container) {
      overlay.remove(); // removes the overlay from the DOM
      container.style.display = 'none'; // hide the container
      container.innerHTML = ''; // clear any remaining innerHTML
    }
  };


  return { init, open, close };
})();

export default staticModalModule;
